import { createActions } from 'redux-actions';

export default createActions({
  SHOW_ERROR: undefined,
  HIDE_NOTIFICATION: undefined,
});
